import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Rect from "../Rect";
import getViewportHeight from "../getViewportHeight";
import getViewportWidth from "../getViewportWidth";
var TOP = /top/;
var BOTTOM = /bottom/;
var LEFT = /left/;
var RIGHT = /right/;

/**
 * Determine whether a rendered layer should be vertically and/or horizontally shifted
 * around the context to remain in view, based on viewport edges.
 */
function calculateAutoflip(config) {
  var autoflipBehavior = config.autoflipBehavior;
  var verticalResult = autoflipBehavior === 'both' || autoflipBehavior === 'vertical' ? // $FlowFixMe - go/flowfixme112
  _objectSpread({}, config, calculateVerticalAutoflip(config)) : config;
  return autoflipBehavior === 'both' || autoflipBehavior === 'horizontal' ? calculateHorizontalAutoflip(verticalResult) : verticalResult;
}

function adjustmentFactor(contextMeetingPoint) {
  if (TOP.test(contextMeetingPoint) || LEFT.test(contextMeetingPoint)) {
    return 0;
  }

  if (BOTTOM.test(contextMeetingPoint) || RIGHT.test(contextMeetingPoint)) {
    return 1;
  }

  return 0.5;
}

function shiftForVerticalCardinal(config) {
  var contextClientRect = config.contextClientRect,
      contextMeetingPoint = config.contextMeetingPoint,
      layerRect = config.layerRect,
      layerMeetingPoint = config.layerMeetingPoint,
      offsetX = config.offsetX;
  var contextLeft = contextClientRect.left,
      contextWidth = contextClientRect.width;
  var layerWidth = layerRect.width;
  var layerLeft = offsetX + contextLeft + adjustmentFactor(contextMeetingPoint) * contextWidth - 0.5 * layerWidth;
  var layerRight = layerLeft + layerWidth;
  var viewportWidth = getViewportWidth();

  var shiftForTop = function shiftForTop() {
    if (layerRight > viewportWidth) {
      return 'topright';
    }

    if (layerLeft < 0) {
      return 'topleft';
    }

    return layerMeetingPoint;
  };

  var shiftForBottom = function shiftForBottom() {
    if (layerRight > viewportWidth) {
      return 'bottomright';
    }

    if (layerLeft < 0) {
      return 'bottomleft';
    }

    return layerMeetingPoint;
  };

  return {
    contextMeetingPoint: contextMeetingPoint,
    layerMeetingPoint: layerMeetingPoint === 'top' ? shiftForTop() : shiftForBottom()
  };
}

function shiftForHorizontalCardinal(config) {
  var contextClientRect = config.contextClientRect,
      contextMeetingPoint = config.contextMeetingPoint,
      layerRect = config.layerRect,
      layerMeetingPoint = config.layerMeetingPoint,
      offsetY = config.offsetY;
  var contextTop = contextClientRect.top,
      contextHeight = contextClientRect.height;
  var layerHeight = layerRect.height;
  var layerTop = offsetY + contextTop + adjustmentFactor(contextMeetingPoint) * contextHeight - 0.5 * layerHeight;
  var layerBottom = layerTop + layerHeight;
  var viewportHeight = getViewportHeight();

  var shiftForLeft = function shiftForLeft() {
    if (layerBottom > viewportHeight) {
      return 'bottomleft';
    }

    if (layerTop < 0) {
      return 'topleft';
    }

    return layerMeetingPoint;
  };

  var shiftForRight = function shiftForRight() {
    if (layerBottom > viewportHeight) {
      return 'bottomright';
    }

    if (layerTop < 0) {
      return 'topright';
    }

    return layerMeetingPoint;
  };

  return {
    contextMeetingPoint: contextMeetingPoint,
    layerMeetingPoint: layerMeetingPoint === 'left' ? shiftForLeft() : shiftForRight()
  };
}

function calculateHorizontalAutoflip(config) {
  var contextClientRect = config.contextClientRect,
      contextMeetingPoint = config.contextMeetingPoint,
      flipAxis = config.flipAxis,
      layerRect = config.layerRect,
      layerMeetingPoint = config.layerMeetingPoint,
      offsetX = config.offsetX;

  if (layerMeetingPoint === 'top' || layerMeetingPoint === 'bottom') {
    return shiftForVerticalCardinal(config);
  }

  var layerWidth = layerRect.width;
  var contextRectPoint = LEFT.test(contextMeetingPoint) ? contextClientRect.left : contextClientRect.right;

  if (LEFT.test(layerMeetingPoint)) {
    var viewportWidth = getViewportWidth();
    var layerRight = contextRectPoint + layerWidth + offsetX;

    if (layerRight > viewportWidth) {
      return {
        contextMeetingPoint: flipAxis === 'context-center' ? flipHorizontally(contextMeetingPoint) : contextMeetingPoint,
        layerMeetingPoint: flipHorizontally(layerMeetingPoint)
      };
    }
  }

  if (RIGHT.test(layerMeetingPoint)) {
    var layerLeft = contextRectPoint - layerWidth + offsetX;

    if (layerLeft < 0) {
      return {
        contextMeetingPoint: flipAxis === 'context-center' ? flipHorizontally(contextMeetingPoint) : contextMeetingPoint,
        layerMeetingPoint: flipHorizontally(layerMeetingPoint)
      };
    }
  }

  return {
    contextMeetingPoint: contextMeetingPoint,
    layerMeetingPoint: layerMeetingPoint
  };
}

function calculateVerticalAutoflip(config) {
  var contextClientRect = config.contextClientRect,
      contextMeetingPoint = config.contextMeetingPoint,
      flipAxis = config.flipAxis,
      layerRect = config.layerRect,
      layerMeetingPoint = config.layerMeetingPoint,
      offsetY = config.offsetY;

  if (layerMeetingPoint === 'left' || layerMeetingPoint === 'right') {
    return shiftForHorizontalCardinal(config);
  }

  var layerHeight = layerRect.height; // If the layer is positioned above the context, flip it if its top is
  // above the top of the viewport.

  if (BOTTOM.test(layerMeetingPoint)) {
    var layerTop = contextClientRect.top - layerHeight + offsetY;

    if (layerTop > 0) {
      return {
        contextMeetingPoint: contextMeetingPoint,
        layerMeetingPoint: layerMeetingPoint
      };
    }

    return {
      contextMeetingPoint: flipAxis === 'context-center' ? flipVertically(contextMeetingPoint) : contextMeetingPoint,
      layerMeetingPoint: flipVertically(layerMeetingPoint)
    };
  } // If the layer is positioned below the context, flip it if its bottom is
  // below the bottom of the viewport.


  if (TOP.test(layerMeetingPoint)) {
    var viewportHeight = getViewportHeight();
    var layerBottom = contextClientRect.top + contextClientRect.height + layerHeight + offsetY;

    if (layerBottom < viewportHeight) {
      return {
        contextMeetingPoint: contextMeetingPoint,
        layerMeetingPoint: layerMeetingPoint
      };
    }

    return {
      contextMeetingPoint: flipAxis === 'context-center' ? flipVertically(contextMeetingPoint) : contextMeetingPoint,
      layerMeetingPoint: flipVertically(layerMeetingPoint)
    };
  }

  return {
    contextMeetingPoint: contextMeetingPoint,
    layerMeetingPoint: layerMeetingPoint
  };
}

function flipVertically(meetingPoint) {
  switch (meetingPoint) {
    case 'top':
      return 'bottom';

    case 'topleft':
      return 'bottomleft';

    case 'topright':
      return 'bottomright';

    case 'bottom':
      return 'top';

    case 'bottomleft':
      return 'topleft';

    case 'bottomright':
      return 'topright';

    default:
      return meetingPoint;
  }
}

function flipHorizontally(meetingPoint) {
  switch (meetingPoint) {
    case 'left':
      return 'right';

    case 'topleft':
      return 'topright';

    case 'topright':
      return 'topleft';

    case 'right':
      return 'left';

    case 'bottomleft':
      return 'bottomright';

    case 'bottomright':
      return 'bottomleft';

    default:
      return meetingPoint;
  }
}

export default calculateAutoflip;